export default __webpack_public_path__ + "static/media/moneyIcon.159f27f8.svg";